export default __webpack_public_path__ + "static/media/scratchCards.d60e843d.png";